import { useState } from 'react';
import { useTranslation } from '../../i18n';
import { VoiceToneTab }   from './VoiceToneTab';
import { EmojiMapTab }    from './EmojiMapTab';
import { HashtagsTab }    from './HashtagsTab';
import { PartnerTagsTab } from './PartnerTagsTab';
import { ExamplesTab }    from './ExamplesTab';
import { AssetsTab }      from './AssetsTab';

const TABS = [
  { key: 'voiceTone', Component: VoiceToneTab },
  { key: 'emojiMap',  Component: EmojiMapTab },
  { key: 'hashtags',  Component: HashtagsTab },
  { key: 'partners',  Component: PartnerTagsTab },
  { key: 'examples',  Component: ExamplesTab },
  { key: 'assets',    Component: AssetsTab },
];

export function BrandSettings() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('voiceTone');
  const ActiveComponent = TABS.find((tab) => tab.key === activeTab).Component;

  return (
    <div>
      <header className="page-header">
        <h1 className="page-header__title">{t('brand.title')}</h1>
        <div className="page-header__subtitle">{t('brand.subtitle')}</div>
      </header>

      <div className="tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={'tab' + (activeTab === tab.key ? ' tab--active' : '')}
            onClick={() => setActiveTab(tab.key)}
          >
            {t(`brand.tabs.${tab.key}`)}
          </button>
        ))}
      </div>

      <ActiveComponent />
    </div>
  );
}
